import React from 'react';
import { Translation } from 'react-i18next';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import ChangeEmail
  from 'components/dashboard/security-content/ChangeEmail';
import EmailUnsubscribe
  from 'components/dashboard/security-content/EmailUnsubscribe';
import ChangePassword
  from 'components/dashboard/security-content/ChangePassword';
import TwoFactorAuthentication
  from 'components/dashboard/security-content/TwoFactorAuthentication';

import './SecurityPageContent.css';

const SecurityPageContent = () => (
  <Translation>
    {(t) => (
      <div className="security-page-content__component">
        <DashboardFormSection header={t("PASSWORD & SECURITY")}>
          {/* Email */}
          <div className="section email">
            <ChangeEmail />
          </div>

          {/* Email Unsubscribe */}
          <div className="section unsubscribe">
            <EmailUnsubscribe />
          </div>

          {/* Password */}
          <div className="section password">
            <ChangePassword />
          </div>

          {/* Two Factor Authentication */}
          <div className="section two-factor">
            <TwoFactorAuthentication />
          </div>

        </DashboardFormSection>
      </div>
    )}
  </Translation>
);

export default SecurityPageContent;
